var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 27
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-support_svg__a",
    x1: "71.527%",
    x2: "23.895%",
    y1: "0%",
    y2: "95.439%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-support_svg__b",
    x1: "60.043%",
    x2: "37.821%",
    y1: "0%",
    y2: "95.439%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF684A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-support_svg__c",
    x1: "60.322%",
    x2: "37.483%",
    y1: "0%",
    y2: "95.439%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF684A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4959"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-support_svg__a)",
    stroke: "#3B385E",
    strokeWidth: 1.43,
    d: "M12.82 23.225c3.097 0 7.2-2.915 8.245-8.606C22.11 8.93 20.02.29 12.821.29c-7.2 0-9.389 8.639-8.245 14.33 1.144 5.69 5.148 8.605 8.245 8.605z",
    transform: "translate(2 1.85)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B385E",
    d: "M15.914 20.981h-1.893a1.037 1.037 0 01-1.037-1.036v-.653c0-.573.465-1.036 1.037-1.036h1.893c.573 0 1.036.463 1.036 1.036v.653c0 .572-.463 1.036-1.036 1.036"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B385E",
    strokeWidth: 1.43,
    d: "M23.053 12.696c0 4.03-3.392 6.922-7.421 6.922h-.664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-support_svg__b)",
    stroke: "#3B385E",
    strokeWidth: 1.51,
    d: "M20.672 15.739c2.479 0 4.553-2.01 4.553-4.488 0-2.48-2.074-4.49-4.553-4.49v8.978z",
    transform: "translate(2 1.85)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-support_svg__c)",
    stroke: "#3B385E",
    strokeWidth: 1.51,
    d: "M5.13 15.739c-2.478 0-4.615-2.01-4.615-4.488 0-2.48 2.137-4.49 4.615-4.49v8.978z",
    transform: "translate(2 1.85)"
  }))));
}
export default SvgIcSupport;